import CardiacArrest from '@juvare/common-web-ui/icons/CardiacArrest';
import ChildAbduction from '@juvare/common-web-ui/icons/ChildAbduction';
import CodeStroke from '@juvare/common-web-ui/icons/CodeStroke';
import GenericMedicalEmergency from '@juvare/common-web-ui/icons/GenericMedicalEmergency';
import InfantAbduction from '@juvare/common-web-ui/icons/InfantAbduction';
import MissingPatient from '@juvare/common-web-ui/icons/MissingPatient';
import MissingSeniorPatient from '@juvare/common-web-ui/icons/MissingSeniorPatient';
import PagerOutlinedIcon from '@juvare/common-web-ui/icons/PagerOutlined';
import PatientFall from '@juvare/common-web-ui/icons/PatientFall';
import RecycleIcon from '@juvare/common-web-ui/icons/Recycle';
import Triage from '@juvare/common-web-ui/icons/Triage';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BallotIcon from '@mui/icons-material/Ballot';
import BusAlertIcon from '@mui/icons-material/BusAlert';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import ErrorIcon from '@mui/icons-material/Error';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import FlashOffIcon from '@mui/icons-material/FlashOff';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import ForkLeftIcon from '@mui/icons-material/ForkLeft';
import GppBadIcon from '@mui/icons-material/GppBad';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import HubIcon from '@mui/icons-material/Hub';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import PublicIcon from '@mui/icons-material/Public';
import SensorsIcon from '@mui/icons-material/Sensors';
import SevereColdIcon from '@mui/icons-material/SevereCold';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import TerrainIcon from '@mui/icons-material/Terrain';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import VolcanoIcon from '@mui/icons-material/Volcano';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WarningIcon from '@mui/icons-material/Warning';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WindPowerIcon from '@mui/icons-material/WindPower';
import React from 'react';
export const templateIcons = {
    fire: {
        icon: LocalFireDepartmentIcon,
        tooltip: 'Fire',
        'aria-label': 'Fire',
    },
    volcano: {
        icon: VolcanoIcon,
        tooltip: 'Volcano',
        'aria-label': 'Volcano',
    },
    thunderstorm: {
        icon: ThunderstormIcon,
        'aria-label': 'Thunderstorm',
        tooltip: 'Thunderstorm',
    },
    windPower: {
        icon: WindPowerIcon,
        'aria-label': 'Wind Power',
        tooltip: 'Wind Power',
    },
    flashOn: {
        icon: FlashOnIcon,
        'aria-label': 'Flash On',
        tooltip: 'Flash On',
    },
    flashOff: {
        icon: FlashOffIcon,
        'aria-label': 'Flash Off',
        tooltip: 'Flash Off',
    },
    lightbulb: {
        icon: LightbulbIcon,
        'aria-label': 'LightBulb',
        tooltip: 'LightBulb',
    },
    severeCold: {
        icon: SevereColdIcon,
        'aria-label': 'Severe Cold',
        tooltip: 'Severe Cold',
    },
    snow: {
        icon: AcUnitIcon,
        'aria-label': 'Snow',
        tooltip: 'Snow',
    },
    favorite: {
        icon: FavoriteIcon,
        'aria-label': 'Favorite',
        tooltip: 'Favorite',
    },
    coronavirus: {
        icon: CoronavirusIcon,
        'aria-label': 'Coronavirus',
        tooltip: 'Coronavirus',
    },
    deviceThermostat: {
        icon: DeviceThermostatIcon,
        'aria-label': 'Device Thermostat',
        tooltip: 'Device Thermostat',
    },
    recycling: {
        icon: RecycleIcon,
        'aria-label': 'Recycling',
        tooltip: 'Recycling',
    },
    energySavingsLeaf: {
        icon: EnergySavingsLeafIcon,
        'aria-label': 'Energy Savings Leaf',
        tooltip: 'Energy Savings Leaf',
    },
    error: {
        icon: ErrorIcon,
        'aria-label': 'Error',
        tooltip: 'Error',
    },
    warning: {
        icon: WarningIcon,
        'aria-label': 'Warning',
        tooltip: 'Warning',
    },
    gppBad: {
        icon: GppBadIcon,
        'aria-label': 'GPP Bad',
        tooltip: 'GPP Bad',
    },
    gppGood: {
        icon: GppGoodIcon,
        'aria-label': 'GPP Good',
        tooltip: 'GPP Good',
    },
    gppMaybe: {
        icon: GppMaybeIcon,
        'aria-label': 'GPP Maybe',
        tooltip: 'GPP Maybe',
    },
    hourglassFull: {
        icon: HourglassFullIcon,
        'aria-label': 'Hourglass Full',
        tooltip: 'Hourglass Full',
    },
    watchLater: {
        icon: WatchLaterIcon,
        'aria-label': 'Watch Later',
        tooltip: 'Watch Later',
    },
    volunteerActivism: {
        icon: VolunteerActivismIcon,
        'aria-label': 'Volunteer Activism',
        tooltip: 'Volunteer Activism',
    },
    busAlert: {
        icon: BusAlertIcon,
        'aria-label': 'Bus Alert',
        tooltip: 'Bus Alert',
    },
    carCrash: {
        icon: CarCrashIcon,
        'aria-label': 'Car Crash',
        tooltip: 'Car Crash',
    },
    public: {
        icon: PublicIcon,
        'aria-label': 'Public',
        tooltip: 'Public',
    },
    terrain: {
        icon: TerrainIcon,
        'aria-label': 'Terrain',
        tooltip: 'Terrain',
    },
    timelapse: {
        icon: TimelapseIcon,
        'aria-label': 'Timelapse',
        tooltip: 'Timelapse',
    },
    wbTwilight: {
        icon: WbTwilightIcon,
        'aria-label': 'WB Twilight',
        tooltip: 'WB Twilight',
    },
    sensors: {
        icon: SensorsIcon,
        'aria-label': 'Sensors',
        tooltip: 'Sensors',
    },
    hub: {
        icon: HubIcon,
        'aria-label': 'Hub',
        tooltip: 'Hub',
    },
    infantAbduction: {
        icon: InfantAbduction,
        'aria-label': 'Infant  Abduction',
        tooltip: 'Infant Abduction',
    },
    childAbduction: {
        icon: ChildAbduction,
        'aria-label': 'Child Abduction',
        tooltip: 'Child Abduction',
    },
    missingPatient: {
        icon: MissingPatient,
        'aria-label': 'Missing Patient',
        tooltip: 'Missing Patient',
    },
    missingSeniorPatient: {
        icon: MissingSeniorPatient,
        'aria-label': 'Missing Senior Patient',
        tooltip: 'Missing Senior Patient',
    },
    genericMedicalEmergency: {
        icon: GenericMedicalEmergency,
        'aria-label': 'Generic Medical Emergency',
        tooltip: 'Generic Medica lEmergency',
    },
    patientFall: {
        icon: PatientFall,
        'aria-label': 'Patient Fall',
        tooltip: 'Patient Fall',
    },
    codeStroke: {
        icon: CodeStroke,
        'aria-label': 'Code Stroke',
        tooltip: 'Code Stroke',
    },
    cardiacArrest: {
        icon: CardiacArrest,
        'aria-label': 'Cardiac Arrest',
        tooltip: 'Cardiac Arrest',
    },
    monitorHeart: {
        icon: MonitorHeartIcon,
        'aria-label': 'Monitor Heart',
        tooltip: 'Monitor Heart',
    },
    forkLeft: {
        icon: ForkLeftIcon,
        'aria-label': 'Fork Left',
        tooltip: 'Fork Left',
    },
    triage: {
        icon: Triage,
        'aria-label': 'Triage',
        tooltip: 'Triage',
    },
    ballot: {
        icon: BallotIcon,
        'aria-label': 'Ballot',
        tooltip: 'Ballot',
    },
};
export const channelText = (channel, t) => {
    switch (channel) {
        case 'email':
            return t('common.channels.email');
        case 'sms':
            return t('common.channels.sms');
        case 'voice':
            return t('common.channels.voice');
        case 'push':
            return t('common.channels.push');
        case 'inbox':
            return t('common.channels.inbox');
        case 'fax':
            return t('common.channels.fax');
        case 'pager':
            return t('common.channels.pager');
        case 'whatsapp':
            return t('common.channels.whatsapp');
        default:
            return 'Unknown';
    }
};
export const channelIcon = {
    sms: React.createElement(SpeakerNotesOutlinedIcon, null),
    voice: React.createElement(PhoneEnabledOutlinedIcon, null),
    email: React.createElement(MailOutlineOutlinedIcon, null),
    push: React.createElement(NotificationsIcon, null),
    inbox: React.createElement(InboxOutlinedIcon, null),
    fax: React.createElement(FaxOutlinedIcon, null),
    pager: React.createElement(PagerOutlinedIcon, null),
    whatsapp: React.createElement(WhatsAppIcon, null),
};
